import React from "react";
import { Reveal } from "../shared/Reveal";

export default function WhoWeAre() {
  return (
    <section id="who-we-are" className="whoweare" data-testid="who-we-are">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">WHO WE ARE</Reveal>
        <Reveal className="wwa-lead" tag="p">
          Energy Vault Group is an <b>Integrated Energy Intelligence</b> company — helping organisations
          identify, understand and eliminate the energy waste hidden across their buildings and estates.
        </Reveal>
        <Reveal className="wwa-body" tag="p">
          With <b>over 30 years of energy experience</b>, we now have the technology to identify, monitor and
          <b> remove all energy waste</b> — continuously, and in real time.
        </Reveal>
        <Reveal className="wwa-body" tag="p">
          We integrate granular diagnosis, digitalisation, <b>Centralised Intelligence Infrastructure (CII)</b>,
          Artificial Intelligence and Virtual Energy Management into one connected <span className="g">Digital Nervous System (DNS).</span>
        </Reveal>
        <Reveal className="wwa-body" tag="p">
          The DNS gives a building the ability to <b>see, understand and respond</b> to how energy and critical
          assets are performing — minute by minute.
        </Reveal>
        <Reveal className="wwa-body" tag="p">
          This delivers waste elimination — ultimately leading to lower costs, proactive asset management,
          audit-ready carbon and ESG reporting, and the intelligent foundation from which buildings can
          increasingly think for themselves.
        </Reveal>
        <Reveal className="wwa-tagline" tag="div">We don&rsquo;t assume. <span className="g">We measure.</span></Reveal>
        <div className="wwa-pills">
          <Reveal className="wwa-pill" tag="span">Knowledge Before Investment</Reveal>
          <Reveal className="wwa-pill" tag="span">Making the Invisible Visible</Reveal>
        </div>
      </div>
    </section>
  );
}
